import React from 'react';
import { VALIDATION } from 'constant';
import { _t } from 'utils';
import { form, formField } from 'types';

export const createRegistryForm = ({ onNameChange }) => form({
  fields: [
    formField.text({
      name: 'name',
      title: _t('Name'),
      onBlur: onNameChange,
    }),
    formField.dropdown({
      name: 'location',
      title: _t('Location'),
    }),
  ],
  validations: [
    {
      name: 'name',
      type: VALIDATION.REQUIRED,
    },
    {
      name: 'name',
      type: VALIDATION.REGEX,
      regex: /^[a-z][-a-z0-9]{1,61}[a-z0-9]$/,
      message: _t('NAME_VALIDATION_DESCRIPTION'),
    },
    {
      name: 'location',
      type: VALIDATION.REQUIRED,
    },
  ],
  isCancel: false,
});

export const editRegistryForm = form({
  fields: [
    formField.object({
      name: 'garbageCollectionSchedule',
      title: _t('CONTAINER_REGISTRY.PROPERTIES.GARBAGE_COLLECTION_SCHEDULE'),
      fields: [
        formField.dropdown({
          name: 'days',
          title: _t('day'),
          options: [
            ['Sunday', _t('days.sunday')],
            ['Monday', _t('days.monday')],
            ['Tuesday', _t('days.tuesday')],
            ['Wednesday', _t('days.wednesday')],
            ['Thursday', _t('days.thursday')],
            ['Friday', _t('days.friday')],
            ['Saturday', _t('days.saturday')],
          ],
        }),
        formField.time({ name: 'time', title: _t('TIME_UTC') }),
      ],
    }),
  ],
  validations: [],
  isCancel: false,
});

export const accessTokenForm = (repositories) => form({
  fieldsValues: {
    status: 'enabled',
  },
  fields: [
    formField.text({
      name: 'name',
      title: _t('Name'),
      setVisibility: (e) => !e.id,
    }),
    formField.switch({
      name: 'status',
      setTitle: (e) => `${_t('ACCESS_TOKEN.STATUS')} (${e?.status === 'enabled' ? _t('ACCESS_TOKEN.ENABLED') : _t('ACCESS_TOKEN.DISABLED')})`,
      setValueFrom: (e) => (e ? 'enabled' : 'disabled'),
      setValueTo: (e) => (e === 'enabled'),
    }),
    formField.dateTime({
      name: 'expiryDate',
      title: _t('ACCESS_TOKEN.EXPIRY_DATE'),
    }),
    formField.array({
      isAddButton: false,
      setVisibility: (e) => !e.id,
      name: 'scopes',
      title: _t('ACCESS_TOKEN.SCOPES'),
      initValues: {
        type: 'repository',
        actions: ['*'],
      },
      onChangeSetInitValues: (current, old) => {
        if (old.type !== 'registry' && current.type === 'registry'
          && current.actions.length === 1 && current.actions.includes('*')) {
          return {
            actions: ['push', 'pull'],
          };
        }
        if (old.type !== 'repository' && current.type === 'repository'
          && current.actions.length === 2 && current.actions.includes('push') && current.actions.includes('pull')) {
          return {
            actions: ['*'],
          };
        }
        return {};
      },
      actionButtonName: _t('ACCESS_TOKEN.ADD_SCOPE'),
      setItemTitle: (e) => (
        <div>
          <div>
            {`${_t('Name')}: ${e.name || '*'}`}
          </div>
          <div>
            {`${_t('Type')}: ${e.type} (${e.actions.join(', ')})`}
          </div>
        </div>
      ),
      icon: 'user-lock',
      fields: [
        formField.autocomplete({
          name: 'name',
          freeSolo: true,
          title: _t('Name'),
          placeholder: '*',
          options: repositories,
          info: (
            <div>
              <ul>
                <li>
                  <strong>Custom</strong>
                  &nbsp;
                  {_t('ACCESS_TOKEN.SCOPE_NAME_INFO_TEXT.CUSTOM')}
                </li>
                <li>
                  <strong>Wildcard</strong>
                  &nbsp;
                  {_t('ACCESS_TOKEN.SCOPE_NAME_INFO_TEXT.CLEAR')}
                </li>
              </ul>
            </div>
          ),
        }),
        formField.dropdown({
          name: 'type', title: _t('Type'), options: ['repository', 'registry'],
        }),
        formField.commonSelector({
          name: 'actions',
          title: _t('ACCESS_TOKEN.SELECT_ACTION'),
          helpText: _t('ACCESS_TOKEN.SELECT_ACTION_HELPER_TEXT'),
          subTitle: _t('ACCESS_TOKEN.SELECT_ACTION_HELPER_TEXT_SUBTITLE'),
          isCollapsed: true,
          isMultiple: true,
          itemIcon: 'unlock',
          setItemTitle: (e) => e.name,
          valuePropName: 'name',
          items: [
            { name: '*', exclusive: true },
            { name: 'pull' },
            { name: 'push' },
            { name: 'delete' },
          ],
        }),
      ],
      validations: [
        { name: 'actions', type: VALIDATION.REQUIRED },
        {
          name: 'name',
          type: VALIDATION.REGEX,
          regex: /^([-_a-z0-9/.]+[*]?|[*])$/,
          message: _t('COMMON.VALIDATION_TEXTS.SEE_INFO_VALIDATION_DESCRIPTION'),
        },
      ],
    }),
  ],
  validations: [
    { name: 'name', type: VALIDATION.REQUIRED },
    { name: 'scopes', type: VALIDATION.REQUIRED },
    {
      name: 'name',
      type: VALIDATION.REGEX,
      regex: /^[a-z][-a-z0-9]{1,61}[a-z0-9]$/,
      message: _t('COMMON.VALIDATION_TEXTS.NAME_VALIDATION_DESCRIPTION'),
    },
  ],
});
